// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2y4xw","tab":"ProcedureTabs_tab__C0DL_"};